import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function BonnieDocuments() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.bonnie?.documents || [];
  return (
    <NotesMainPanel
      title={t('bonnie.documentsTitle')}
      subtitle={t('bonnie.documentsSubtitle')}
      items={items}
      emptyTitle={t('bonnie.documentsEmpty')}
      emptySubtitle={t('bonnie.documentsEmptyBody')}
    />
  );
}
